import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookieManager } from "react-cookie-manager";
import { useTranslation } from 'react-i18next';

import './base/components/ConsentManagement/react-cookie-manager.less'

function CookieManagerWrapper({ children }) {
  const { t } = useTranslation();
  return (
    <CookieManager
      enableFloatingButton={true}
      essentialCookies={['kc_token', 'kc_refreshToken']}
      cookieCategories={{
        Analytics: false,
        Social: false,
        Advertising: false,
      }}
      translations={{
        title: t('Cookie_title'),
        message: t('Cookie_message'),
        buttonText: t('Cookie_buttonText'),
        declineButtonText: t('Cookie_declineButtonText'),
        manageButtonText: t('Cookie_manageButtonText'),
        privacyPolicyText: t('Cookie_privacyPolicyText'),
        manageTitle: t('Cookie_manageTitle'),
        manageMessage: t('Cookie_manageMessage'),
        manageEssentialTitle: t('Cookie_manageEssentialTitle'),
        manageEssentialSubtitle: t('Cookie_manageEssentialSubtitle'),
        manageEssentialStatus: t('Cookie_manageEssentialStatus'),
        manageEssentialStatusButtonText: t('Cookie_manageEssentialStatusButtonText'),
        // Intentional: passing the tokens as their own values preserves them through i18next interpolation.
        // The cookie-manager library substitutes {{status}} and {{date}} itself at runtime.
        // Calling t() without these values would replace them with empty strings.
        manageCookiesStatus: t('Cookie_manageCookiesStatus', { status: '{{status}}', date: '{{date}}' }),
        manageCookiesStatusConsented: t('Cookie_manageCookiesStatusConsented'),
        manageCookiesStatusDeclined: t('Cookie_manageCookiesStatusDeclined'),
        manageCancelButtonText: t('Cookie_manageCancelButtonText'),
        manageSaveButtonText: t('Cookie_manageSaveButtonText'),
      }}
      showManageButton={true}
      privacyPolicyUrl="/privacy"
      theme="dark"
    >
      {children}
    </CookieManager>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Suspense boundary required: CookieManagerWrapper uses useTranslation(), which suspends if i18n ever switches to async locale loading */}
    <React.Suspense fallback={null}>
      <CookieManagerWrapper>
        <App />
      </CookieManagerWrapper>
    </React.Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
